// For TILT product code migration
export const mapProductCodes = (preTiltCode: string) => {
  const codeMap: Record<string, string> = {
    'SK-AD-CLS-G646': 'SK-AD-BSC-G180',
    'SK-AD-STOUT-G855': 'SK-AD-BRNDBSC-G951',
    'SK-AD-PFM-G295': 'SK-AD-ADV-G675',
    'SK-AD-BRNDPFM-G892': 'SK-AD-BRNDADV-G681',
    'SK-AD-PRM-G934': 'SK-AD-PRM-G611',
    'SK-AD-BSC-G612': 'SK-AD-BSC-G697',
    'SK-AD-BRND-G855': 'SK-AD-BRNDBSC-G951',
    'SK-AD-PFM-G375': 'SK-AD-ADV-G541',
    'SK-AD-BRNDPFM-G701': 'SK-AD-BRNDADV-G681',
    'SK-AD-PRM-G935': 'SK-AD-PRM-G611',
  };

  return codeMap[preTiltCode] || null;
};
